export const DirectInvestmentUploadGridConfig = {
	list: 'DirectInvestmentValuation',
	grid: {
		gridId: 'DirectInvestmentUploadGrid',
		checkbox: false,
		edit: false,
		delete: true,
		sortable: false,
		pageSize: 10,
		height: 500,
		groupable: false
	},
	columns: {
		DIKey: {
			dataName: 'DIKey',
			type: 'string',
			title: 'DIKey',
			width: 100,
			hidden: true
		},
		Validation: {
			dataName: 'Validation',
			type: 'string',
			title: 'Validation',
			width: 130,
			hidden: false
		},
		PartnerPartnerID: {
			dataName: 'PartnerPartnerID',
			type: 'string',
			title: 'Partner Id',
			width: 130,
			hidden: false
		},
		PartnerTitle: {
			dataName: 'PartnerTitle',
			type: 'string',
			title: 'Partner Name',
			width: 150,
			hidden: false
		},
		InvestmentInvestmentID: {
			dataName: 'InvestmentInvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 150,
			hidden: false
		},
		InvestmentTitle: {
			dataName: 'InvestmentTitle',
			type: 'string',
			title: 'Investment',
			width: 130,
			hidden: false
		},
		TaxYear: {
			dataName: 'TaxYear',
			type: 'string',
			title: 'Tax Year',
			width: 100,
			hidden: false
		},
		TaxQuarter: {
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quater',
			width: 130,
			hidden: false
		},
		CommitmentFunded: {
			dataName: 'CommitmentFunded',
			type: 'string',
			title: 'Commitments Funded',
			template: '#=kendo.toString(CommitmentFunded, "c")#',
			width: 200,
			hidden: false
		},
		CommitmentRemaining: {
			dataName: 'CommitmentRemaining',
			type: 'string',
			title: 'Commitments Remaining',
			template: '#=kendo.toString(CommitmentRemaining, "c")#',
			width: 220,
			hidden: false
		},
		PriorCashDistribution: {
			dataName: 'PriorCashDistribution',
			type: 'string',
			title: 'Previous Cash Distributions',
			template: '#=kendo.toString(PriorCashDistribution, "c")#',
			width: 230,
			hidden: false
		},
		ProjectedValue: {
			dataName: 'ProjectedValue',
			type: 'string',
			title: 'Projected Value',
			template: '#=kendo.toString(ProjectedValue, "c")#',
			width: 170,
			hidden: false
		},
		CurrentValue: {
			dataName: 'CurrentValue',
			type: 'string',
			title: 'Current Value',
			template: '#=kendo.toString(CurrentValue, "c")#',
			width: 160,
			hidden: false
		},

	}
}